/* ==========================================================================
   Manuel Kur Çevirici (Toserof) — tema içi para birimi dönüştürücü
   --------------------------------------------------------------------------
   Mağaza para birimi TRY. Tema ayarlarındaki SABİT kurlarla (1 USD = X ₺ vb.)
   vitrindeki tüm fiyatlar (koleksiyon, ürün, sepet, sepet çekmecesi, arama,
   hızlı görünüm…) seçili para birimine çevrilir. Ödeme (checkout) Shopify
   tarafında her zaman TRY ile alınır; bu dosya yalnızca GÖSTERİMİ değiştirir.

   Nasıl çalışır
   1) Liquid'in bastığı her fiyat `<span class="money">1,234.56TL</span>`
      biçimindedir. Bu span'lar taranır, TRY tutarı kuruş olarak data-*'ya
      yazılır ve metin seçili para birimine göre yeniden basılır. Section
      render / AJAX ile gelen yeni span'lar MutationObserver ile yakalanır.
   2) Temanın JS fiyat biçimleyicisi `window.webvista.formatPriceAmount`
      sarmalanır: TRY kuruş alan çağrılar seçili para biriminde döner
      (varyant yüzen fiyatı, kargo ücreti, ücretsiz kargo çubuğu vb.).
   3) Seçici widget: masaüstünde [data-currency-slot="header"|"toolbar"],
      mobilde [data-currency-slot="fab"|"footer"] yuvasına yerleşir; yuva
      yoksa sol altta yüzer. Seçim localStorage'da saklanır.

   Yapılandırma: snippets/manual-currency.liquid → window.TKUR_CONFIG
   ========================================================================== */
(function () {
  "use strict";

  var cfg = window.TKUR_CONFIG;
  if (!cfg || !cfg.enabled) return;
  if (window.__tkurLoaded) return;
  window.__tkurLoaded = true;

  var STORAGE_KEY = "tkur_currency";
  /* Liquid .money span'ları + temanın JS ile doldurduğu, sarmalama öncesi basılmış olabilen fiyat alanları */
  var PRICE_SELECTOR = ".money, [data-floating-price]";
  var BASE = "TRY";

  /* ---- Para birimi tanımları -------------------------------------------
     pre: sembol önde ($1,234.56) — yoksa kod sonda (1,234.56 AED). dec: ondalık. */
  var META = {
    TRY: { flag: "🇹🇷", name: "Türk Lirası",        fmt: function (n) { return n + "TL"; } },
    USD: { flag: "🇺🇸", name: "US Dollar",           pre: "$" },
    EUR: { flag: "🇪🇺", name: "Euro",                pre: "€" },
    GBP: { flag: "🇬🇧", name: "British Pound",       pre: "£" },
    CAD: { flag: "🇨🇦", name: "Canadian Dollar",     pre: "CA$" },
    AUD: { flag: "🇦🇺", name: "Australian Dollar",   pre: "A$" },
    CHF: { flag: "🇨🇭", name: "Swiss Franc" },
    AED: { flag: "🇦🇪", name: "UAE Dirham" },
    SAR: { flag: "🇸🇦", name: "Saudi Riyal" },
    QAR: { flag: "🇶🇦", name: "Qatari Riyal" },
    KWD: { flag: "🇰🇼", name: "Kuwaiti Dinar", dec: 3 },
    BHD: { flag: "🇧🇭", name: "Bahraini Dinar", dec: 3 },
    OMR: { flag: "🇴🇲", name: "Omani Rial", dec: 3 },
    JOD: { flag: "🇯🇴", name: "Jordanian Dinar", dec: 3 },
    IQD: { flag: "🇮🇶", name: "Iraqi Dinar", dec: 0 },
    EGP: { flag: "🇪🇬", name: "Egyptian Pound" },
    LBP: { flag: "🇱🇧", name: "Lebanese Pound", dec: 0 },
    MAD: { flag: "🇲🇦", name: "Moroccan Dirham" },
    DZD: { flag: "🇩🇿", name: "Algerian Dinar" },
    TND: { flag: "🇹🇳", name: "Tunisian Dinar", dec: 3 },
    LYD: { flag: "🇱🇾", name: "Libyan Dinar", dec: 3 },
    ILS: { flag: "🇮🇱", name: "Israeli Shekel",      pre: "₪" },
    RUB: { flag: "🇷🇺", name: "Russian Ruble" },
    UAH: { flag: "🇺🇦", name: "Ukrainian Hryvnia" },
    KZT: { flag: "🇰🇿", name: "Kazakhstani Tenge" },
    AZN: { flag: "🇦🇿", name: "Azerbaijani Manat" },
    GEL: { flag: "🇬🇪", name: "Georgian Lari" },
    UZS: { flag: "🇺🇿", name: "Uzbekistani Som", dec: 0 },
    PLN: { flag: "🇵🇱", name: "Polish Zloty" },
    RON: { flag: "🇷🇴", name: "Romanian Leu" },
    BGN: { flag: "🇧🇬", name: "Bulgarian Lev" },
    CZK: { flag: "🇨🇿", name: "Czech Koruna" },
    HUF: { flag: "🇭🇺", name: "Hungarian Forint", dec: 0 },
    SEK: { flag: "🇸🇪", name: "Swedish Krona" },
    NOK: { flag: "🇳🇴", name: "Norwegian Krone" },
    DKK: { flag: "🇩🇰", name: "Danish Krone" },
    RSD: { flag: "🇷🇸", name: "Serbian Dinar" },
    MKD: { flag: "🇲🇰", name: "Macedonian Denar" },
    ALL: { flag: "🇦🇱", name: "Albanian Lek" },
    BAM: { flag: "🇧🇦", name: "Bosnian Mark" },
    JPY: { flag: "🇯🇵", name: "Japanese Yen",        pre: "¥", dec: 0 },
    CNY: { flag: "🇨🇳", name: "Chinese Yuan",        pre: "CN¥" },
    KRW: { flag: "🇰🇷", name: "South Korean Won",   pre: "₩", dec: 0 },
    INR: { flag: "🇮🇳", name: "Indian Rupee",        pre: "₹" },
    PKR: { flag: "🇵🇰", name: "Pakistani Rupee" },
    IDR: { flag: "🇮🇩", name: "Indonesian Rupiah", dec: 0 },
    MYR: { flag: "🇲🇾", name: "Malaysian Ringgit" },
    NGN: { flag: "🇳🇬", name: "Nigerian Naira",      pre: "₦" },
    ZAR: { flag: "🇿🇦", name: "South African Rand" },
    BRL: { flag: "🇧🇷", name: "Brazilian Real",      pre: "R$" },
    MXN: { flag: "🇲🇽", name: "Mexican Peso",        pre: "MX$" },
  };
  /* Tanımsız kod: genel bayrak, ad = kod, kod sonda */
  function metaFor(code) {
    return META[code] || { flag: "💱", name: code };
  }

  /* Otomatik modda ülke → para birimi (kuru tanımlıysa) */
  var COUNTRY_CURRENCY = {
    US: "USD", GB: "GBP", CA: "CAD", AU: "AUD", CH: "CHF", AE: "AED", SA: "SAR", QA: "QAR", KW: "KWD",
    BH: "BHD", OM: "OMR", JO: "JOD", IQ: "IQD", EG: "EGP", LB: "LBP", MA: "MAD", DZ: "DZD", TN: "TND",
    LY: "LYD", IL: "ILS", RU: "RUB", UA: "UAH", KZ: "KZT", AZ: "AZN", GE: "GEL", UZ: "UZS", PL: "PLN",
    RO: "RON", BG: "BGN", CZ: "CZK", HU: "HUF", SE: "SEK", NO: "NOK", DK: "DKK", RS: "RSD", MK: "MKD",
    AL: "ALL", BA: "BAM", JP: "JPY", CN: "CNY", KR: "KRW", IN: "INR", PK: "PKR", ID: "IDR", MY: "MYR",
    NG: "NGN", ZA: "ZAR", BR: "BRL", MX: "MXN",
  };

  var EU = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"];

  /* rates: { USD: 48, EUR: 52.5, ... } → 1 birim yabancı = X TRY
     cfg.rates: tema ayarındaki sabit alanlar; cfg.extra: "KOD=kur" satırları (ör. "CHF=60") */
  var rates = {};
  function addRate(code, val) {
    code = String(code || "").trim().toUpperCase();
    var v = parseFloat(String(val == null ? "" : val).trim().replace(",", "."));
    if (/^[A-Z]{3}$/.test(code) && code !== BASE && v > 0) rates[code] = v;
  }
  Object.keys(cfg.rates || {}).forEach(function (code) { addRate(code, cfg.rates[code]); });
  String(cfg.extra || "").split(/[\n;]+/).forEach(function (line) {
    var m = line.match(/^\s*([A-Za-z]{3})\s*[=:]\s*([\d.,]+)\s*$/);
    if (m) addRate(m[1], m[2]);
  });
  var available = [BASE].concat(Object.keys(rates));
  if (available.length < 2) return; // çevrilecek kur yok

  /* ---- Varsayılan / kayıtlı seçim -------------------------------------- */
  function isForeignVisitor() {
    if (cfg.country && cfg.country !== "TR") return true;
    if (cfg.locale && cfg.locale !== "tr") return true;
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      var lang = (navigator.language || "").toLowerCase();
      if (tz && tz !== "Europe/Istanbul" && lang.indexOf("tr") !== 0) return true;
    } catch (e) {}
    return false;
  }

  function autoCurrency() {
    if (!isForeignVisitor()) return BASE;
    var c = cfg.country || "";
    var mapped = COUNTRY_CURRENCY[c];
    if (mapped && rates[mapped]) return mapped;
    if (rates.EUR && EU.indexOf(c) !== -1) return "EUR";
    if (rates.USD) return "USD";
    return Object.keys(rates)[0] || BASE;
  }

  function readSaved() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return available.indexOf(v) !== -1 ? v : null;
    } catch (e) { return null; }
  }

  function save(code) {
    try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  }

  var active = readSaved();
  if (!active) {
    if (cfg.defaultMode === "auto") active = autoCurrency();
    else if (available.indexOf(cfg.defaultMode) !== -1) active = cfg.defaultMode;
    else active = BASE;
  }

  /* ---- Sayı biçimleme --------------------------------------------------- */
  function applyRounding(value) {
    if (cfg.rounding === "99") {
      var c = Math.ceil(value);
      return c >= 1 ? c - 0.01 : value;
    }
    if (cfg.rounding === "int") return Math.round(value);
    return value;
  }

  function groupThousands(str) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /** TRY kuruş → seçili para biriminde biçimli metin */
  function format(cents, code) {
    code = code || active;
    var value = cents / 100;
    if (code === BASE) {
      var t = value.toFixed(2).split(".");
      var tn = groupThousands(t[0]) + "." + t[1];
      return cfg.withCode ? tn + " TRY" : META.TRY.fmt(tn);
    }
    var m = metaFor(code);
    var dec = typeof m.dec === "number" ? m.dec : 2;
    value = applyRounding(value / rates[code]);
    var fixed = value.toFixed(dec);
    var parts = fixed.split(".");
    var num = groupThousands(parts[0]) + (parts[1] ? "." + parts[1] : "");
    if (m.pre) return m.pre + num + (cfg.withCode ? " " + code : "");
    return num + " " + code;
  }

  /** "1,234.56TL" / "1,234.56 TRY" / "₺1.234,56" → kuruş (int) veya null */
  function parseTRY(text) {
    if (!text) return null;
    var t = String(text).replace(/\s+/g, "");
    var m = t.match(/^(?:₺|TL|TRY)?([\d.,]+)(?:TL|TRY|₺)?$/i);
    if (!m) return null;
    var raw = m[1];
    var lastComma = raw.lastIndexOf(",");
    var lastDot = raw.lastIndexOf(".");
    var decSep = null;
    var lastSep = Math.max(lastComma, lastDot);
    if (lastSep !== -1 && raw.length - lastSep - 1 === 2) {
      decSep = raw.charAt(lastSep);
    }
    var normalized;
    if (decSep) {
      var intPart = raw.slice(0, lastSep).replace(/[.,]/g, "");
      normalized = intPart + "." + raw.slice(lastSep + 1);
    } else {
      normalized = raw.replace(/[.,]/g, "");
    }
    var n = parseFloat(normalized);
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }

  /* ---- .money span dönüştürme ------------------------------------------ */
  function convertEl(el) {
    var text = el.textContent;
    var ds = el.dataset;
    if (ds.tkurOut !== undefined && text === ds.tkurOut) {
      if (ds.tkurCur === active) return; // zaten doğru
    } else {
      // İlk görüş ya da tema metni yeniden yazdı → TRY olarak yeniden oku
      var cents = parseTRY(text);
      if (cents === null) return;
      ds.tkurTry = String(cents);
      ds.tkurOrig = text;
    }
    var out = active === BASE ? ds.tkurOrig : format(parseInt(ds.tkurTry, 10), active);
    ds.tkurCur = active;
    ds.tkurOut = out;
    if (el.textContent !== out) el.textContent = out;
  }

  function convertAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(PRICE_SELECTOR);
    for (var i = 0; i < nodes.length; i++) convertEl(nodes[i]);
    if (root && root.matches && root.matches(PRICE_SELECTOR)) convertEl(root);
    updateWidgetState();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      convertAll();
    });
  }

  function observe() {
    if (!document.body) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === "childList" && (m.addedNodes.length || m.removedNodes.length)) { schedule(); return; }
        if (m.type === "characterData") {
          var p = m.target.parentElement;
          if (p && p.matches(PRICE_SELECTOR) && m.target.data !== p.dataset.tkurOut) { schedule(); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---- JS biçimleyici sarmalama ---------------------------------------- */
  function patchFormatter() {
    var wv = window.webvista;
    if (!wv || wv.__tkurPatched || typeof wv.formatPriceAmount !== "function") return;
    var orig = wv.formatPriceAmount;
    wv.formatPriceAmount = function (amount, currency) {
      if (active !== BASE && (!currency || currency === BASE)) {
        return format(Math.round(Number(amount) || 0), active);
      }
      return orig.apply(this, arguments);
    };
    wv.__tkurPatched = true;
  }

  /* ---- Widget ------------------------------------------------------------ */
  var widget, btn, list;

  function buildWidget() {
    if (!cfg.showSelector) return;
    widget = document.createElement("div");
    widget.className = "tkur-widget";
    widget.setAttribute("data-tkur-widget", "");

    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "tkur-widget__btn";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "Para birimi");
    widget.appendChild(btn);

    list = document.createElement("ul");
    list.className = "tkur-widget__list";
    list.setAttribute("role", "listbox");
    list.hidden = true;
    available.forEach(function (code) {
      var li = document.createElement("li");
      li.setAttribute("role", "option");
      var b = document.createElement("button");
      b.type = "button";
      b.className = "tkur-widget__opt";
      b.setAttribute("data-tkur-pick", code);
      b.innerHTML =
        '<span class="tkur-widget__flag">' + metaFor(code).flag + "</span>" +
        '<span class="tkur-widget__code">' + code + "</span>" +
        '<span class="tkur-widget__name">' + metaFor(code).name + "</span>";
      li.appendChild(b);
      list.appendChild(li);
    });
    if (cfg.note) {
      var note = document.createElement("li");
      note.className = "tkur-widget__note";
      note.textContent = cfg.note;
      list.appendChild(note);
    }
    widget.appendChild(list);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      toggle(list.hidden);
    });
    list.addEventListener("click", function (e) {
      var pick = e.target.closest("[data-tkur-pick]");
      if (!pick) return;
      setCurrency(pick.getAttribute("data-tkur-pick"));
      toggle(false);
    });
    document.addEventListener("click", function (e) {
      if (widget && !widget.contains(e.target)) toggle(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") toggle(false);
    });

    place();
    if (desktopMQ.addEventListener) desktopMQ.addEventListener("change", place);
    else if (desktopMQ.addListener) desktopMQ.addListener(place);
    updateWidgetState();
  }

  function toggle(open) {
    if (!list) return;
    list.hidden = !open;
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    widget.classList.toggle("is-open", !!open);
  }

  var DESKTOP_SLOTS = ['header', 'toolbar'];
  var MOBILE_SLOTS = ['fab', 'footer', 'mobile'];
  var desktopMQ = window.matchMedia("(min-width: " + (parseInt(cfg.desktopMin, 10) || 768) + "px)");

  function findSlot(names) {
    for (var i = 0; i < names.length; i++) {
      var el = document.querySelector('[data-currency-slot="' + names[i] + '"]');
      if (el) return el;
    }
    return null;
  }

  function place() {
    if (!widget) return;
    var target =
      (desktopMQ.matches ? findSlot(DESKTOP_SLOTS) : findSlot(MOBILE_SLOTS)) ||
      document.querySelector("[data-currency-slot]");
    var slotName = target ? target.getAttribute("data-currency-slot") : "";
    if (!target) {
      target = document.body;
      widget.classList.add("tkur-widget--floating");
    } else {
      widget.classList.remove("tkur-widget--floating");
    }
    if (!target.contains(widget)) target.appendChild(widget);
    widget.className = widget.className.replace(/\s*tkur-widget--slot-\S+/g, "");
    if (slotName) widget.classList.add("tkur-widget--slot-" + slotName);
    widget.classList.toggle("tkur-widget--fab", slotName === "fab");
  }

  function updateWidgetState() {
    if (!widget) return;
    var m = metaFor(active);
    btn.innerHTML =
      '<span class="tkur-widget__flag">' + m.flag + "</span>" +
      '<span class="tkur-widget__code">' + active + "</span>" +
      '<svg class="tkur-widget__chev" viewBox="0 0 12 12" width="10" height="10" aria-hidden="true"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    var opts = list.querySelectorAll("[data-tkur-pick]");
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].getAttribute("data-tkur-pick") === active;
      opts[i].classList.toggle("is-active", on);
      opts[i].parentElement.setAttribute("aria-selected", on ? "true" : "false");
    }
  }

  /* ---- Dışa açık API ----------------------------------------------------- */
  function setCurrency(code) {
    if (available.indexOf(code) === -1 || code === active) return;
    active = code;
    save(code);
    document.documentElement.setAttribute("data-tkur-currency", code);
    convertAll();
    document.dispatchEvent(new CustomEvent("tkur:change", { detail: { currency: code, rate: rates[code] || 1 } }));
  }

  window.TKUR = {
    get currency() { return active; },
    rates: rates,
    available: available,
    set: setCurrency,
    format: format,
    parseTRY: parseTRY,
    convert: convertAll,
  };

  /* ---- Başlat ------------------------------------------------------------ */
  document.documentElement.setAttribute("data-tkur-currency", active);
  patchFormatter();

  function init() {
    patchFormatter();
    buildWidget();
    convertAll();
    observe();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  window.addEventListener("load", patchFormatter);
})();
